var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.5C7.14062 6.5 8.5 5.16406 8.5 3.5C8.5 1.85938 7.14062 0.5 5.5 0.5C3.83594 0.5 2.5 1.85938 2.5 3.5C2.5 5.16406 3.83594 6.5 5.5 6.5ZM5.5 1.25C6.71875 1.25 7.75 2.28125 7.75 3.5C7.75 4.74219 6.71875 5.75 5.5 5.75C4.25781 5.75 3.25 4.74219 3.25 3.5C3.25 2.28125 4.25781 1.25 5.5 1.25ZM6.67188 7.625H4.30469C2.05469 7.625 0.25 9.45312 0.25 11.7031C0.25 12.1484 0.601562 12.5 1.04688 12.5H9.92969C10.375 12.5 10.75 12.1484 10.75 11.7031C10.75 9.45312 8.92188 7.625 6.67188 7.625ZM9.92969 11.75H1.04688C1.02344 11.75 1 11.7266 1 11.7031C1 9.875 2.47656 8.375 4.30469 8.375H6.67188C8.5 8.375 10 9.875 10 11.7031C10 11.7266 9.95312 11.75 9.92969 11.75Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e8284965eef0649c049016847e027822.svg";
export { ForwardRef as ReactComponent };